import { useState } from "react";
import { Copy, Check, Share2 } from "lucide-react";

export const ReferralBox = ({ code, testPrefix }) => {
  const [copied, setCopied] = useState(false);
  const link = `${window.location.origin}/?ref=${code}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(link); } catch { /* clipboard blocked; link stays selectable */ }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const share = `https://wa.me/?text=${encodeURIComponent(`I just joined the Trading Nifty early-access waitlist — AI trading strategies for NSE & BSE. Join here: ${link}`)}`;

  return (
    <div className="mt-4 rounded-lg border border-[var(--tn-line)] bg-[var(--tn-bg)] p-4" data-testid={`${testPrefix}-referral-box`}>
      <p className="text-sm font-medium">Move up 5 places for every friend who joins</p>
      <div className="flex flex-col sm:flex-row gap-2 mt-3">
        <input readOnly value={link} onFocus={(e) => e.target.select()} className="tn-input h-9 font-mono text-xs" data-testid={`${testPrefix}-referral-link`} />
        <button type="button" onClick={copy} className="tn-btn h-9 shrink-0" data-testid={`${testPrefix}-referral-copy-btn`}>
          {copied ? <Check size={15} /> : <Copy size={15} />} {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <a href={share} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-sm text-[var(--tn-green)] hover:underline mt-3" data-testid={`${testPrefix}-referral-whatsapp`}>
        <Share2 size={14} /> Share on WhatsApp
      </a>
    </div>
  );
};
